'use client';

import { memo } from 'react';
import PropTypes from 'prop-types';

import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import useScreen from 'hooks/useScreen';

const MobileAndTabletOnly = ({ children, fallback = null }) => {
  const isBrowser = useIsBrowser();
  const { isMobileOrTablet } = useScreen();

  // In new Consumer app, to prevent SSR bug always render on server. After components
  // are mounted in browser, we should conditionally only render when on mobile or tablet device.
  return (isNewConsumerApp && !isBrowser) || isMobileOrTablet
    ? children
    : fallback;
};

MobileAndTabletOnly.propTypes = {
  children: PropTypes.node,
};

export default memo(MobileAndTabletOnly);
